import { API_TYPE } from '@umu/umu-fetch';
const BasePath = '/uapi/v1/enterprise';

export const EnterpriseAPI = {
    ENTERPRISE_GET_SETUP: {
        url: `${BasePath}/get-setup`,
        type: API_TYPE.GET,
    },

    /**
     * AGL 服务到期提醒弹窗查询
     * https://tickets.umu.work/browse/AI-2919
     */
    AGL_EXPIRY_REMINDER_POPUP: {
        url: '/uapi/v1/agl/enterprise-expiry-reminder-popup',
        type: API_TYPE.GET,
    },

    /**
     * AGL 服务到期提醒弹窗标记已弹窗
     * https://tickets.umu.work/browse/AI-2919
     */
    AGL_EXPIRY_REMINDER_POPUP_SHOWN: {
        url: '/uapi/v1/agl/enterprise-expiry-reminder-popup-shown',
        type: API_TYPE.POST,
    },
};
